import { FC } from 'react';
import { Flex, Icon, Heading, Text } from '@/_components';
import styles from './SendQuestionnaireItem.module.css';
import { SendQuestionnaireItemProps } from './SendQuestionnaireItem.types';
import { getClasses } from '@/_utils/classnames';

export const SendQuestionnaireItem: FC<SendQuestionnaireItemProps> = ({
  onClick,
  icon,
  title,
  description,
  isDisabled,
  id,
}) => {
  const sendQuestionnaireItemClasses = getClasses(
    id,
    styles.sendQuestionnaireItem,
    {
      [styles.sendQuestionnaireItemDisabled]: isDisabled,
    },
  );

  return (
    <Flex
      gap={6}
      isColumn={true}
      onClick={onClick}
      isGrowing={true}
      isCentered={true}
      className={sendQuestionnaireItemClasses}
    >
      <Icon name={icon} size={24} />
      <Heading level={4}>{title}</Heading>
      <Text
        type="small"
        textAlign="center"
        className={styles.sendQuestionnaireItem__text}
      >
        {description}
      </Text>
    </Flex>
  );
};
